import React, {useEffect, useState} from "react";


import {Link, useNavigate} from "react-router-dom";
import Countdown from "react-countdown";
import {useForceUpdate} from "../../services/misc.functions";
import {homeHippodrome, homeHippodromeSubject, todayResults, todayResultsSubject} from "../../store/misc.store";
import {courseColors} from "../../constants/bulletin.constants";
import paths from "../../paths";
import {HippodromeWidget} from "../../shared/hippodrome/hippodrome";
import DatePicker from "react-datepicker";

export function DailyRaces() {
    const forceUpdate = useForceUpdate();
    const navigate = useNavigate();

      useEffect(() => {

        let homeHippodromeSubject_subscription = homeHippodromeSubject.subscribe((res: any) => {
            forceUpdate();
        })

        return () => {
            homeHippodromeSubject_subscription.unsubscribe();
        }

    }, []);


    useEffect(() => {
        let todayResultsSubject_subscription = todayResultsSubject.subscribe((res: any) => {
            forceUpdate();
        })
        return () => {
            todayResultsSubject_subscription.unsubscribe();
        }
    }, []);



    return <>
        <div className="page-title-wrapper ">
            <HippodromeWidget/>
        </div>
        <div className={"container daily-race-page"}>
            {homeHippodrome?.runs?.map((run: any, runsIndex: number) => {
                return (<React.Fragment key={`runs-i-${runsIndex}`}>
                    <div className={"daily-race-container"}>
                        <div className={"d-flex justify-content-between pt-2 px-2"}>
                            <div className={"d-flex align-items-center"}>
                                <p className="text-small fw-normal">
                                    {run.no}.Koşu
                                </p>
                                <div className="race-start">
                                    <span className="fw-normal text-xsmall">{run.time}</span>
                                </div>
                            </div>
                            <div>

                                {run.status === 0 &&
                                    <>
                                        <Countdown
                                            renderer={({hours, minutes, seconds, completed}) => {
                                                if (completed) {
                                                    // Render a completed state
                                                    return (
                                                        <div
                                                            className={"d-flex justify-content-center align-items-center remaining-time"}>
                                                            <div
                                                                className={"fw-medium text-white text-xsmall text-center"}>
                                                                Başlamak Üzere
                                                            </div>
                                                        </div>
                                                    );
                                                } else {
                                                    // Render a countdown
                                                    return (
                                                        <div
                                                            className={"d-flex justify-content-center align-items-center remaining-time"}>
                                                            <div
                                                                className={"fw-medium text-white text-xsmall text-center me-1"}>Kalan
                                                                Süre:
                                                            </div>
                                                            <span style={{minWidth: "55px"}}
                                                                  className={"fw-medium text-white text-xsmall text-center"}>{hours.toString().padStart(2, "0")}:{minutes.toString().padStart(2, "0")}:{seconds.toString().padStart(2, "0")}</span>
                                                        </div>
                                                    );
                                                }
                                            }}
                                            date={run.running_date}
                                        />
                                    </>}
                                {
                                    (run.status === 1 || run.status === 2) && <>
                                        <div
                                            className={"d-flex justify-content-center align-items-center resulted-time"}>
                                            <div
                                                className={"fw-medium text-white text-xsmall text-center"}>
                                                Sonuçlandı
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>

                        </div>
                        <div className={"divider"}>

                        </div>
                        <div className={"d-flex align-items-center justify-content-between px-2 mt-2"}>
                         <span className="text-xsmall text-white course"
                               style={{backgroundColor: courseColors[run.course]}}>{run.course}</span>
                            <span
                                className="text-xsmall"
                                style={{color: '#666666'}}>{run.distance}m | {run.group} | {run.type_detail}</span>
                        </div>

                        {run.status === 0 && <div className={"row mt-2"}>
                            <div className={"col-6 race-button-left"} onClick={() => {
                                window.location.href = paths.bettingFob.url;
                            }}>
                                Sabit İhtimalli <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12"
                                                           viewBox="0 0 6 12" fill="none">
                                <path d="M1 11L5 6L1 1" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round"
                                      stroke-linejoin="round"></path>
                            </svg>
                            </div>
                            <div className={"col-6 race-button-right"} onClick={() => {
                                window.location.href = paths.betting.url;
                            }}>
                                Müşterek <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12"
                                                    viewBox="0 0 6 12" fill="none">
                                <path d="M1 11L5 6L1 1" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round"
                                      stroke-linejoin="round"></path>
                            </svg>
                            </div>

                        </div>}

                        {
                            (run.status === 1 || run.status === 2) && <>
                                <div className={"divider"}></div>
                                <div style={{paddingBottom: "16px", paddingLeft: "16px", paddingRight: "16px", paddingTop: "0"}}
                                     className={"d-flex justify-content-start align-items-center"}>
                                    <div
                                        className={"fw-medium text-xsmall text-center"}>
                                        Sonuçlar
                                        : {todayResults[homeHippodrome.keyword]?.runsMap[run.no.toString()]?.horses.map((el: any) => el.no).join(", ")}
                                    </div>
                                </div>
                            </>
                        }

                    </div>
                </React.Fragment>)
            })}
        </div>


    </>

}
